var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0391 1.97424H6.46344C3.16861 1.97424 0.48999 4.65286 0.48999 7.94769V12.978C0.48999 16.2728 3.16861 18.9514 6.46344 18.9514H16.3857C17.1276 18.9514 17.857 19.1526 18.4858 19.5299L21.6674 21.4414C22.0196 21.6552 22.4094 21.7558 22.7992 21.7558C23.1891 21.7558 23.5412 21.6552 23.8808 21.4665C24.585 21.0767 25 20.3599 25 19.555V7.94769C25 4.65286 22.3214 1.97424 19.0265 1.97424H19.0391ZM23.1262 19.555C23.1262 19.7185 23.0256 19.794 22.9627 19.8317C22.8999 19.8694 22.7867 19.9072 22.6483 19.8317L19.4541 17.9202C18.5235 17.3669 17.4672 17.0651 16.3857 17.0651H6.46344C4.21239 17.0651 2.37634 15.229 2.37634 12.978V7.94769C2.37634 5.69664 4.21239 3.8606 6.46344 3.8606H19.0391C21.2902 3.8606 23.1262 5.69664 23.1262 7.94769V19.555Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7762 9.51978H12.7636C12.248 9.51978 11.833 9.94735 11.833 10.463C11.833 10.9786 12.2606 11.4061 12.7762 11.4061C13.2918 11.4061 13.7194 10.9786 13.7194 10.463C13.7194 9.94735 13.2918 9.51978 12.7762 9.51978Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74591 9.51978H7.73334C7.21773 9.51978 6.80273 9.94735 6.80273 10.463C6.80273 10.9786 7.23031 11.4061 7.74591 11.4061C8.26151 11.4061 8.68909 10.9786 8.68909 10.463C8.68909 9.94735 8.26151 9.51978 7.74591 9.51978Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8065 9.51978H17.7939C17.2783 9.51978 16.8633 9.94735 16.8633 10.463C16.8633 10.9786 17.2909 11.4061 17.8065 11.4061C18.3221 11.4061 18.7496 10.9786 18.7496 10.463C18.7496 9.94735 18.3221 9.51978 17.8065 9.51978Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.2fdcb46040c01e68c5b46c84c5d0f845.svg";
export { ForwardRef as ReactComponent };